import { render, staticRenderFns } from "./TituloComponente.vue?vue&type=template&id=485241da&"
import script from "./TituloComponente.vue?vue&type=script&lang=js&"
export * from "./TituloComponente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports